import React, { useEffect, useMemo, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) {
    return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8081';
  }
  if (envUrl.includes('your-cloud-run-url') || envUrl.includes('placeholder')) {
    return process.env.NODE_ENV === 'production' ? '' : 'http://localhost:8081';
  }
  if (envUrl.includes('run.app')) {
    return envUrl;
  }
  if (process.env.NODE_ENV === 'production') {
    return envUrl;
  }
  return 'http://localhost:8081';
};

export default function InboxCounter() {
  const { currentUser } = useAuth();
  const [unread, setUnread] = useState(0);
  const [pending, setPending] = useState(0);
  const [visible, setVisible] = useState(document.visibilityState === 'visible');
  const API_BASE_URL = useMemo(getApiBaseUrl, []);

  useEffect(() => {
    const onVis = () => setVisible(document.visibilityState === 'visible');
    document.addEventListener('visibilitychange', onVis);
    return () => document.removeEventListener('visibilitychange', onVis);
  }, []);

  useEffect(() => {
    let intervalId;
    let cancelled = false;
    async function fetchCounts() {
      try {
        if (!currentUser) return;
        const token = await currentUser.getIdToken();
        const res = await fetch(`${API_BASE_URL}/api/chat/unread-count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) return;
        const data = await res.json();
        if (!cancelled) {
          setUnread(typeof data.unread === 'number' ? data.unread : 0);
          setPending(typeof data.pendingRequests === 'number' ? data.pendingRequests : 0);
        }
      } catch {
        // ignore transient errors
      }
    }
    if (currentUser) {
      fetchCounts();
      intervalId = setInterval(() => {
        if (visible) fetchCounts();
      }, 10000);
    }
    return () => {
      cancelled = true;
      if (intervalId) clearInterval(intervalId);
    };
  }, [currentUser, API_BASE_URL, visible]);

  if (!currentUser) return null;
  const total = unread + pending;

  return (
    <button
      type="button"
      aria-label="Inbox"
      onClick={() => window.location.assign('/chat')}
      style={{
        position: 'fixed',
        zIndex: 9999,
        right: '24px',
        bottom: '24px',
        background: total > 0 ? 'linear-gradient(135deg, #2563eb, #7c3aed)' : '#111827',
        color: 'white',
        border: total > 0 ? '1px solid rgba(255,255,255,0.4)' : '1px solid rgba(255,255,255,0.15)',
        padding: '8px 12px',
        borderRadius: '999px',
        boxShadow: total > 0
          ? '0 10px 30px rgba(15,23,42,0.65)'
          : '0 6px 18px rgba(15,23,42,0.4)',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        backdropFilter: 'blur(8px)',
        WebkitBackdropFilter: 'blur(8px)',
        maxWidth: '210px'
      }}
    >
      <span style={{ fontSize: '16px' }}>💬</span>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
        <span style={{ fontSize: '12px', fontWeight: 600 }}>
          Chat inbox
        </span>
        <span style={{
          fontSize: '10px',
          opacity: 0.9,
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}>
          {total > 0 ? `${total} new ${total === 1 ? 'update' : 'updates'}` : 'No new messages'}
        </span>
      </div>
      <span
        style={{
          marginLeft: '4px',
          background: total > 0 ? '#f97316' : '#4b5563',
          color: 'white',
          borderRadius: '999px',
          padding: '2px 8px',
          fontWeight: 700,
          fontSize: '11px',
          minWidth: '22px',
          textAlign: 'center'
        }}
      >
        {total}
      </span>
    </button>
  );
}


